import AddressLineOne from './AddressLineOne';


class AddressLineThree extends AddressLineOne {

    static defaultProps = {
        'field': 'addressLine3',
        'id': 'addressline3'
    };
}

export default AddressLineThree;
